<template>
  <div class="layout-container" :class="{pad46: $route.path !== '/user'}">
    <router-view/>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/" icon="bag">报价单</van-tabbar-item>
      <van-tabbar-item to="/order" icon="bill">订单</van-tabbar-item>
      <!-- <van-tabbar-item to="/shoppingCart" icon="shopping-cart">购物车</van-tabbar-item>
      <van-tabbar-item to="/profile" icon="user">我的</van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data () {
    return {
      tabbarMap: {
        Quotation: 0,
        Order: 1,
        ShoppingCart: 2,
        Profile: 3
      },
      active: 0
    }
  },
  watch: {
    '$route.name': function (newVal) {
      this.active = this.tabbarMap[newVal] || 0
    }
  },
  created() {
    this.active = this.tabbarMap[this.$route.name] || 0
  }
}
</script>

<style lang='scss' scoped>
@import "@/styles/variables.scss";
.pad46 {
  padding-top: 46px;
}
.layout-container {
  height: 100%;
  padding-bottom: 50px;
  // logo区域
  .logo {
    background: url("~@/assets/logo.png") no-repeat;
    background-size: cover;
    width: 100px;
    height: 30px;
  }
  // 搜索按钮
  .search-btn {
    background-color: $primary;
    width: 100px;
    font-size: 14px;
    .van-icon {
      color: #fff;
    }
  }
}
</style>
